import { render } from "./DashBoardCompForReqCat.vue?vue&type=template&id=6a94cfc4&scoped=true"
import script from "./DashBoardCompForReqCat.vue?vue&type=script&lang=js"
export * from "./DashBoardCompForReqCat.vue?vue&type=script&lang=js"

import "./DashBoardCompForReqCat.vue?vue&type=style&index=0&id=6a94cfc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a94cfc4"]])

export default __exports__